module.exports = __webpack_public_path__ + "static/media/p.8abb1490.png";